// Header.jsx

import React from "react";
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname;

  let productName = "Product Details";
  let orderId = "Order Details";
  let paymentId = "Payment Details";
  let customerName = "Customer Details";

  /* PRODUCT NAME */
  if (path.includes("/product-details/") || path.includes("/edit-product/")) {
    const id = path.split("/")[2];

    const products = JSON.parse(localStorage.getItem("products")) || [];

    const product = products.find((p) => p && String(p.id) === String(id));

    productName = product?.name || "Product Details";
  }

  /* ORDER ID */
  if (path.includes("/order-details/")) {
    orderId = "#" + path.split("/")[2];
  }

  /* PAYMENT ID (clicked row data) */
  if (path === "/payment-details") {
    paymentId = location.state?.paymentId || "Payment Details";
  }

  /* CUSTOMER NAME FIX */
  if (path.includes("/customer-details/")) {
    customerName =
      location.state?.customer?.name ||
      location.state?.name ||
      "Customer Details";
  }

  return (
    <div className="dashboard-header">
      {/* HOME */}
      <FaHome style={{ cursor: "pointer" }} onClick={() => navigate("/")} />

      {/* ADMIN PROFILE */}
      {path === "/admin-profile" ? (
        <>
          <IoIosArrowForward />
          <span className="active-page">Admin Profile</span>
        </>
      ) : (
        <>
          <IoIosArrowForward />
          {/* DASHBOARD */}
          {(path === "/" || path === "/dashboard") && (
            <span className="active-page">Dashboard</span>
          )}
          {/* PRODUCTS */}
          {path === "/products" && (
            <span className="active-page">Products</span>
          )}
          {/* ADD PRODUCT */}
          {path === "/add-product" && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/products")}
              >
                Products
              </span>

              <IoIosArrowForward />
              <span className="active-page">Add Product</span>
            </>
          )}
          {/* PRODUCT DETAILS */}
          {path.includes("/product-details/") && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/products")}
              >
                Products
              </span>

              <IoIosArrowForward />
              <span className="active-page">{productName}</span>
            </>
          )}
          {/* EDIT PRODUCT */}
          {path.includes("/edit-product/") && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/products")}
              >
                Products
              </span>

              <IoIosArrowForward />

              <span
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/product-details/${path.split("/")[2]}`)
                }
              >
                {productName}
              </span>

              <IoIosArrowForward />
              <span className="active-page">Edit Product</span>
            </>
          )}
          {/* ORDERS */}
          {path === "/orders" && <span className="active-page">Orders</span>}
          {/* ORDER DETAILS */}
          {path.includes("/order-details/") && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/orders")}
              >
                Orders
              </span>

              <IoIosArrowForward />
              <span className="active-page">{orderId}</span>
            </>
          )}
          {/* PAYMENTS */}
          {path === "/payments" && (
            <span className="active-page">Payments</span>
          )}
          {/* PAYMENT DETAILS */}
          {path === "/payment-details" && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/payments")}
              >
                Payments
              </span>

              <IoIosArrowForward />
              <span className="active-page">{paymentId}</span>
            </>
          )}
          {/* CUSTOMERS */}
          {path === "/customers" && (
            <span className="active-page">Customers</span>
          )}
          {/* CUSTOMER DETAILS */}
          {path.includes("/customer-details/") && (
            <>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/customers")}
              >
                Customers
              </span>

              <IoIosArrowForward />
              <span className="active-page">{customerName}</span>
            </>
          )}
           {/* CONTENT & SETTINGS */}
          {path === "/content-settings" && (
            <span className="active-page">Content & Settings</span>
          )}
          {/* NOTIFICATIONS */}
          {path === "/notifications" && (
            <span className="active-page">Notifications</span>
          )}
        </>
      )}
    </div>
  );
};

export default Header;
